import { render } from "./ModelField.vue?vue&type=template&id=293205fb&ts=true"
import script from "./ModelField.vue?vue&type=script&lang=ts"
export * from "./ModelField.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__